import { render, staticRenderFns } from "./MaliciousNumberNotification.vue?vue&type=template&id=6e6ded63&scoped=true&"
import script from "./MaliciousNumberNotification.vue?vue&type=script&lang=js&"
export * from "./MaliciousNumberNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6ded63",
  null
  
)

export default component.exports